import React from "react";
import "./DisplayError.css";

interface DisplayErrorProps {
  errorCondition?: boolean | { message?: string | React.ReactNode } | null;
  errorMessage?: string | React.ReactNode;
  hideEmptyError?: boolean;
}

const DisplayError: React.FC<DisplayErrorProps> = ({
  errorCondition,
  errorMessage,
  hideEmptyError,
}) => {
  return (
    <React.Fragment>
      {errorCondition ? (
        <div className="mb-4">
          <span className="error">
            {typeof errorCondition === "object" && errorCondition !== null
              ? errorCondition.message || errorMessage
              : errorMessage}
          </span>
        </div>
      ) : (
        !hideEmptyError && (
          <div className="mb-4">
            <span className="empty-error" />
          </div>
        )
      )}
    </React.Fragment>
  );
};

export default DisplayError;
